/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component } from '@angular/core';
import { ErrorLogsService } from 'src/app/core/errorlogs.service';
import { ErrorLogsSearchFilters, ErrorLogsSearchRequest, ErrorLogsSearchResponse } from 'src/app/shared/models/errorlogs.model';
@Component({
  selector: 'app-errorlogs',
  template: `
  <app-errorlogs-filters  (updateFiltersAndSearch)="updateFiltersAndSearch($event)">
  </app-errorlogs-filters>
  <app-errorlogs-table [errorLogs]="errorLogs" (updateRequestAndSearch)="updateRequestAndSearch($event)">
  </app-errorlogs-table>
`
})
export class ErrorlogsComponent {
  public errorLogs = {
    originalRequest: { pageFirstRow: 0, pageSize: 20, sortField: 'TimeStamp', sortOrder: -1 }
  } as ErrorLogsSearchResponse;

  constructor(private errorLogsService: ErrorLogsService) { }

  public updateFiltersAndSearch(filters: ErrorLogsSearchFilters): void {
    this.doSearch({ ...this.errorLogs.originalRequest, ...{ filters } as ErrorLogsSearchRequest });
  }

  public updateRequestAndSearch(request: ErrorLogsSearchRequest): void {
    this.doSearch({ ...this.errorLogs.originalRequest, ...request });
  }

  private doSearch(request: ErrorLogsSearchRequest) {
    this.errorLogsService.search(request).subscribe(a => {
      this.errorLogs = a;
    });
  }
}
